"use client"
import { useShallow } from "zustand/react/shallow"
import {
  useCollectionItemsPurchaseSelectionStore,
  useCollectionItemsSelectionStore,
  useCollectionItemsSellSelectionStore,
} from "./CollectionItemsSelectionProvider"
import type { CollectionItemsPurchaseSelectionStore } from "./collection-items-purchase-selection-store"
import type { CollectionItemsSellSelectionStore } from "./collection-items-sell-selection-store"

export function useCollectionItemsSelection<T>(
  selector: (
    store:
      | CollectionItemsPurchaseSelectionStore
      | CollectionItemsSellSelectionStore,
  ) => T,
): T {
  const { action } = useCollectionItemsSelectionStore()
  const isPurchaseMode = action === "buy"

  const purchaseStore = useCollectionItemsPurchaseSelectionStore(
    useShallow(selector),
  )
  const sellStore = useCollectionItemsSellSelectionStore(useShallow(selector))

  return isPurchaseMode ? purchaseStore : sellStore
}
